import React from "react";

import { ButtonStandard } from "@performyard/py-components";

type ModalActionsProps = {
	selectedCount: number;
	isConfirming: boolean;
	onCancel: () => void;
	onConfirm: () => void;
};

export const ModalActions = ({ selectedCount, isConfirming, onCancel, onConfirm }: ModalActionsProps) => (
	<div className="flex justify-center gap-2">
		<div className="w-fit">
			<ButtonStandard variant="outline" color="neutral" size="large" onClick={onCancel}>
				Cancel
			</ButtonStandard>
		</div>
		<div className="w-fit">
			<ButtonStandard
				variant="solid"
				color="primary"
				size="large"
				onClick={onConfirm}
				disabled={selectedCount === 0 || isConfirming}
			>
				{selectedCount > 0 ? `Select Forms (${selectedCount})` : "Select Forms"}
			</ButtonStandard>
		</div>
	</div>
);
